"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var ramda_1 = require("ramda");
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var TabHeader = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  background: #eaeff3;\n  height: 50px;\n  padding: 0 30px;\n  align-items: flex-end;\n"], ["\n  display: flex;\n  background: #eaeff3;\n  height: 50px;\n  padding: 0 30px;\n  align-items: flex-end;\n"])));
var TabContent = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background: #fff;\n"], ["\n  background: #fff;\n"])));
var TabTitle = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  text-decoration: underline;\n  color: #2362a2;\n  padding: 0 20px;\n  height: 38px;\n  font-size: 15px;\n\n  ", "\n"], ["\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  text-decoration: underline;\n  color: #2362a2;\n  padding: 0 20px;\n  height: 38px;\n  font-size: 15px;\n\n  ",
    "\n"])), function (_a) {
    var isActive = _a.isActive;
    return isActive && styled_components_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      color: #333;\n      text-decoration: none;\n      font-weight: bold;\n      background: #ffffff;\n      border: 1px solid #d5e1eb;\n      border-bottom: 0;\n      box-sizing: border-box;\n      border-radius: 4px 4px 0 0;\n    "], ["\n      color: #333;\n      text-decoration: none;\n      font-weight: bold;\n      background: #ffffff;\n      border: 1px solid #d5e1eb;\n      border-bottom: 0;\n      box-sizing: border-box;\n      border-radius: 4px 4px 0 0;\n    "])));
});
var Tabs = function (_a) {
    var activeId = _a.activeId, children = _a.children, onSelect = _a.onSelect;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(TabHeader, null, react_1.Children.map(children, function (component) {
            var id = ramda_1.path(['props', 'id'], component);
            var title = ramda_1.path(['props', 'title'], component);
            if (component)
                return (react_1.default.createElement(TabTitle, { isActive: id === activeId, onClick: id ? function () { return onSelect(id); } : undefined }, title));
            return react_1.default.createElement(react_1.default.Fragment, null);
        })),
        react_1.default.createElement(TabContent, null, react_1.Children.toArray(children).find(ramda_1.pathEq(['props', 'id'], activeId)))));
};
var Tab = function (_a) {
    var id = _a.id, children = _a.children;
    return react_1.default.createElement("div", { "data-testid": id }, children);
};
Tabs.Tab = Tab;
exports.default = Tabs;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
